import styled from "styled-components";

import { FlexDiv, SVGSprite } from "../../../../components/Atoms";
import { SubmitButton } from "../../../../components/Organisms/FormInputs";
import Typography from "../../../../foundation/Typography/V2";
import theme from "../../../../foundation/Theme";

export const StyledLeftSection = styled(FlexDiv)`
  flex-direction: column;
  margin-right: 48px;
  @media only screen and (max-width: 1079px) {
    margin-right: 0;
    padding: 0 8px;
  }
`;

export const TitleContainer = styled(FlexDiv)`
  gap: 12px;
  align-items: center;
  margin-bottom: 40px;
  padding: 8px;
  @media only screen and (max-width: 1079px) {
    margin-bottom: 16px;
  }
`;

export const FormTitleContainer = styled(FlexDiv)`
  flex-direction: column;
  padding: 8px;
`;

export const Title = styled(Typography)`
  color: ${({ theme }) => theme?.colorsV2?.shyft?.purple_text};
`;

export const SubTitle = styled(Typography)`
  color: ${({ theme }) => theme?.colorsV2?.blueGray?.shade_800};
`;

export const ArrowRight = styled(SVGSprite)`
  height: 26px;
  width: 26px;
  fill: ${({ theme }) => theme?.colorsV2?.shyft?.purple_text};
`;

export const List = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  overflow: hidden;
  &:after {
    z-index: 4;
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 143px;
    width: 100%;
    ${({ maxHeight }) =>
      maxHeight
        ? "background: linear-gradient(0deg, #FFFFFF 43.59%, rgba(255, 255, 255, 0.85) 77.64%, rgba(255, 255, 255, 0) 112.31%);"
        : ""}
  }
`;

export const ListItem = styled(FlexDiv)`
  position: relative;
  padding: 8px 8px 24px 8px;
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    border-left: 2px dashed ${theme.colorsV2.shyft.green};
    left: 17px;
    z-index: 0;
    @media only screen and (max-width: 1079px) {
      left: 13px;
    }
  }
  &:last-child {
    &::before {
      content: none;
    }
  }
  img {
    height: 16px;
    width: 16px;
    margin-right: 16px;
  }
  @media only screen and (max-width: 1079px) {
    padding: 0 0 16px 0;
    img {
      margin: 8px;
    }
  }
`;

export const TimeLineStep = styled(FlexDiv)`
  position: absolute;
  left: 0;
  top: 0;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1.5px solid ${theme.colorsV2.shyft.green};
  z-index: 1;
  margin: 8px 0;
  @media only screen and (max-width: 1079px) {
    margin: 0;
    width: 28px;
    height: 28px;
  }
`;

export const ListItemContent = styled(FlexDiv)`
  flex-direction: column;
  padding-left: 48px;
`;

export const StyledSubmitButton = styled(SubmitButton)`
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  z-index: 5;
  width: max-content;
  button {
    padding: 16px 48px;
    color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  }
`;
